// DiscoverShowMoreWrapper.jsx
'use client';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useParams, useLocation } from 'react-router';

import UniversalComponent from '../component/UniversalComponent.jsx';

import { getFeedCategory } from '../resource/feedUtils.js';

export const DiscoverShowMoreWrapper = ({ isShorts = false }) => {
  const { category: paramCategory } = useParams();
  const { search } = useLocation();
  const category = getFeedCategory({
    category: paramCategory,
    search,
  });
  const isFollowingStoryMore = 'pseudo_following_stories' === category;
  const filename = isFollowingStoryMore
    ? 'Container_FollowingStoryMore'
    : isShorts
      ? 'Container_ShortsMore'
      : 'Container_FeedStoryMore';

  const importer = useMemo(() => {
    switch (filename) {
      case 'Container_FollowingStoryMore':
        return /* #__LOADABLE__ */ () =>
          import('../container/FollowingStoryMore.js');
      case 'Container_ShortsMore':
        return /* #__LOADABLE__ */ () => import('../container/ShortsMore.js');
      case 'Container_FeedStoryMore':
        return /* #__LOADABLE__ */ () =>
          import('../container/FeedStoryMore.js');
      default:
        return;
    }
  }, [filename]);

  return (
    <UniversalComponent
      filename={filename}
      category={category}
      importer={importer}
    />
  );
};

DiscoverShowMoreWrapper.propTypes = {
  isShorts: PropTypes.bool,
};

export default DiscoverShowMoreWrapper;
